// extracted by css-extract-rspack-plugin
export default {"pinnedMessages":"pinned-messages--Bsp4aj1iPc0P3pj5","clippedMessage":"clipped-message--_88Q72XqH5Ia5V7s"};